<template>
  <div>
    <div
      v-if="!datasReady"
      class="loading"
    >
      <a-spin tip="loading" />
    </div>
    <div v-else>
      <a-alert
        :message="invoiceNumTipTxt"
        type="warning"
        show-icon
      />
      <div class="invoice-btn-box">
        <router-link
          v-if="invoiceMoney>=400"
          :to="{ path: '/account/invoiceapply'}"
          class="ant-btn ant-btn-primary"
        >
          {{ $t('message["1040"]') }}
        </router-link>
        <span class="ml-16">{{ priceTip[0] }}<em>{{ invoiceMoney }}{{ priceTip[1] }}</em></span>
      </div>
      <a-table
        :columns="columns"
        :pagination="false"
        :data-source="orderListData"
        class="table-list"
      >
        <div
          slot="proname"
          slot-scope="proname, record"
          class="order-cell"
        >
          <span>{{ record.proname }}</span>
        </div>
        <div
          slot="addtime"
          slot-scope="addtime, record"
          class="order-cell date-time-cell"
        >
          <span>{{ timestampToTime(record.addtime, '-').date }}</span>
          <p>{{ timestampToTime(record.addtime, '-').time }}</p>
        </div>
        <div
          slot="money"
          slot-scope="money, record"
          class="order-cell"
        >
          <span>{{ record.money }}</span>
        </div>
        <div
          slot="paystatusname"
          slot-scope="paystatusname, record"
          class="order-cell"
        >
          <span :class="{'wait-for-pay': record.paystatus === 0}">{{ record.paystatusname }}</span>
        </div>
        <div
          slot="paytime"
          slot-scope="paytime, record"
          class="order-cell"
        >
          <span
            v-if="!record.paytime"
          >—</span>
          <template v-else>
            <div class="date-time-cell">
              <span>{{ timestampToTime(record.addtime, '-').date }}</span>
              <p>{{ timestampToTime(record.addtime, '-').time }}</p>
            </div>
          </template>
        </div>
        <div
          slot="paystatus"
          slot-scope="paystatus, record"
          class="order-cell"
        >
          <a
            href="javascript:;"
            @click="viewItemInfo(record.ordersn)"
          >{{ $t('message["1316"]') }}</a>
        </div>
      </a-table>
      <order-info-dia
        ref="orderInfoDialog"
        :order-data="itemData"
      />
      <div class="loading">
        <a-button
          v-if="orderListData.length >= 10"
          :loading="loading"
          :disabled="loading"
          class="load-more-btn"
          @click="getListDatas"
        >
          {{ $t('message["472"]') }}
        </a-button>
      </div>
    </div>
  </div>
</template>
<script>
import OrderInfoDia from './OrderInfoDia'
import { cloneDeep } from 'lodash'
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'
import { timestampToTime } from '@/store/account/scripts'

export default {
  components: {
    OrderInfoDia
  },
  data () {
    return {
      page: 2,
      loading: false,
      itemData: {}
    }
  },
  computed: {
    ...mapState('account/invoice', ['datasReady', 'invoiceMoney', 'datas']),
    ...mapGetters('account/invoice', ['orderListData']),
    priceTip () {
      return this.$t('message["162"]').split('|')
    },
    invoiceNumTipTxt () {
      return this.$t('message["588"]')
    },
    columns () {
      const columns = [{
        dataIndex: 'ordersn',
        key: 'ordersn',
        title: this.$t('message["245"]')
      }, {
        title: this.$t('message["1675"]'),
        dataIndex: 'comname',
        key: 'comname'
      }, {
        title: this.$t('message["1318"]'),
        key: 'projectname',
        dataIndex: 'projectname'
      }, {
        title: this.$t('message["660"]'),
        key: 'proname',
        dadaIndex: 'proname',
        scopedSlots: { customRender: 'proname' }
      }, {
        title: this.$t('message["126"]'),
        key: 'addtime',
        dadaIndex: 'addtime',
        scopedSlots: { customRender: 'addtime' },
        width: 120
      }, {
        title: this.$t('message["247"]'),
        key: 'money',
        dadaIndex: 'money',
        scopedSlots: { customRender: 'money' },
        width: 90
      }, {
        title: this.$t('message["1646"]'),
        key: 'paystatusname',
        dadaIndex: 'paystatusname',
        scopedSlots: {
          customRender: 'paystatusname'
        },
        width: 80
      }, {
        title: this.$t('message["1596"]'),
        key: 'paytime',
        dadaIndex: 'paytime',
        scopedSlots: { customRender: 'paytime' },
        width: 120
      }, {
        title: this.$t('message["79"]'),
        key: 'paystatus',
        dadaIndex: 'paystatus',
        scopedSlots: { customRender: 'paystatus' },
        width: 60
      }]
      return columns
    }
  },
  async mounted () {
  },
  methods: {
    timestampToTime,
    ...mapMutations('account/invoice', ['setDatas']),
    ...mapActions('account/invoice', ['fetchOrderListDatas', 'fetchOrderInfo', 'fetchPay']),
    async getListDatas () {
      this.loading = true
      let arr = cloneDeep(this.datas)
      const chain = await this.fetchOrderListDatas()
      chain.params({ isinvoice: 0, page: this.page })
        .onSuccess(res => {
          if (res.length) {
            arr.push(...this.datas)
            this.setDatas(arr)
            this.page++
          } else {
            this.setDatas(arr)
            // alert('已加载完毕！')
            this.$message.warning(this.$t('message["1463"]') + '！')
          }
        })
        .fetch()
      this.loading = false
    },
    async viewItemInfo (id) {
      const chain = await this.fetchOrderInfo()
      chain.params({ ordersn: id })
        .onSuccess(res => {
          this.itemData = res
          this.$refs.orderInfoDialog.changeVisible(true)
        })
        .fetch()
    }
  }
}
</script>
<style lang="scss" scoped>
  .invoice-btn-box {
    margin: 24px 0 ;
    em {
      color: #42c27e;
      font-style: normal;
    }
  }
  .date-time-cell {
    font-size: 12px;
    p {
      color: #999;
    }
  }
  .wait-for-pay {
    color: #f6a953;
  }
</style>
